import {
  FETCH_BRANDING_ASYNC,
  FETCH_TENANT_DOMAINS_ASYNC,
  RESET_SAVE_SUCCESS,
  SAVE_BRANDING_ASYNC,
  SELECT_DOMAIN,
} from './constants'

const initialState = {
  data: null,
  selectedDomain: null,
  tenantDomains: [],
  loader: false,
  saving: false,
  saveSuccess: false,
  error: null,
}

export default function emailEncryptionBrandingReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_BRANDING_ASYNC.INITIATE:
      return { ...state, loader: true, error: null }

    case FETCH_BRANDING_ASYNC.SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loader: false,
        error: null,
        selectedDomain: state.selectedDomain,
      }

    case FETCH_BRANDING_ASYNC.ERROR:
      return { ...state, loader: false, error: action.error }

    case SAVE_BRANDING_ASYNC.INITIATE:
      return { ...state, saving: true, saveSuccess: false, error: null }

    case SAVE_BRANDING_ASYNC.SUCCESS:
      return { ...state, data: action.payload.data, saving: false, saveSuccess: true }

    case SAVE_BRANDING_ASYNC.ERROR:
      return { ...state, saving: false, saveSuccess: false, error: action.error }

    case FETCH_TENANT_DOMAINS_ASYNC.SUCCESS:
      return { ...state, tenantDomains: action.payload.domains }

    case FETCH_TENANT_DOMAINS_ASYNC.ERROR:
      return { ...state, tenantDomains: [] }

    case SELECT_DOMAIN:
      return { ...state, selectedDomain: action.payload.domain }

    case RESET_SAVE_SUCCESS:
      return { ...state, saveSuccess: false }

    default:
      return state
  }
}
